import React from 'react';

interface HeaderSectionProps {
  highlight: string;
  title: string;
}

const HeaderSection = ({ highlight, title }: HeaderSectionProps) => {
  return (
    <h1 className="m-0 font-suisse-works text-headline-xxs text-black">
      <span className="mb-8 block font-suisse-intl-mono text-overline-md text-black">
        {highlight}
      </span>
      {title}
    </h1>
  );
};

export default HeaderSection;
